import React from 'react';
import { Outlet } from 'react-router-dom';

export function NoLayout() {
  // no header/footer for pages
  return <Outlet />;
}
